import classnames from 'classnames';
import React from 'react';
import { Field } from 'react-final-form';

import { FormInput } from '../../../../interfaces';
import { useClipboardPasting, useFormInput } from '../../../../libs/hooks';
import { InputLabelComponent } from '../../input-label';
import { InputMessageComponent } from '../../input-message';

export const TextInputComponent: React.FC<FormInput> = React.memo((props: FormInput) => {
  const {
    className,
    clipboardDisabled = false,
    description,
    disabled,
    format,
    info = '',
    label,
    name,
    required = true,
    type = 'text',
    validators,
    ...rest
  } = props;
  const { disabledPasteHandler } = useClipboardPasting(clipboardDisabled);

  const { id, texts, validate, validationKey } = useFormInput({
    description,
    disabled,
    label,
    name,
    required,
    validators,
  });

  return (
    <Field
      component="input"
      data={{ validationKey }}
      format={format}
      name={id}
      type={type}
      validate={validate}>
      {({ input, meta }) => {
        // @NOTE const metaField = useField(...) feature
        // cannot be applied here because of the use of validationKey hack
        // (updating the validation function)
        const error = meta.touched && meta.error;
        return (
          <div
            className={classnames('fr-input-group', className, {
              // eslint-disable-next-line @typescript-eslint/naming-convention
              'fr-input-group--error': !!error,
            })}>
            <InputLabelComponent disabled={disabled} id={id} texts={texts} />
            <input
              {...rest}
              {...input}
              aria-describedby={`${id}-messages`}
              className={classnames('fr-input', {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'fr-input--error': !!error,
              })}
              disabled={disabled}
              id={id}
              required={required}
              type={type}
              onPaste={disabledPasteHandler}
            />
            <InputMessageComponent error={error} id={id} info={info} />
          </div>
        );
      }}
    </Field>
  );
});

TextInputComponent.displayName = 'TextInputComponent';
